<!--FastBI产品-->
<template>
  <div class="xz_buyDialog">
    <el-dialog
      :before-close="restForm"
      :title="isAdd == 'triall' ? '试用产品' : '购买产品'"
      :visible.sync="visible"
      :close-on-click-modal="false"
      width="560px"
    >
      <el-form :model="form" ref="form" :rules="formRules">
        <el-form-item :label-width="formLabelWidth" label="授权客户名称" prop="name">
          <el-input v-model="form.name" :disabled="isAdd === 'edit' ? true : false"></el-input>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" class="ip_main">
          <template slot="label">
            <!-- class="ip_valid" -->
            <div>授权外网地址</div>
          </template>
          <div class="ip_input_main" v-for="(item, index) in auth_ips" :key="index">
            <div style="display: flex;">
              <el-input v-model="item.value" :disabled="isAdd === 'edit' ? true : false"></el-input>
              <!-- isAdd == 'add' &&  -->
              <span v-if="index == 0" class="add_span" @click="addIP">添加</span>
              <!-- isAdd == 'add' &&  -->
              <span v-if="index != 0" class="add_span" @click="removeIp"><i class="el-icon-remove "></i></span>
            </div>
          </div>
        </el-form-item>
        <!-- v-if="isAdd != 'triall' -->
        <el-form-item :label-width="formLabelWidth" class="ip_main">
          <template slot="label">
            <!-- class="ip_valid" -->
            <div>授权内网地址</div>
          </template>
          <div class="ip_input_main" v-for="(item, index) in Internal_auth_ips" :key="index">
            <div style="display: flex;">
              <el-input v-model="item.value" :disabled="isAdd === 'edit' ? true : false"></el-input>
              <span v-if="index == 0" class="add_span" @click="addInternalIP">添加</span>
              <span v-if="index != 0" class="add_span" @click="removeInternalIp"><i class="el-icon-remove "></i></span>
            </div>
          </div>
        </el-form-item>
        <div v-if="isAdd != 'edit'">
          <el-form-item :label-width="formLabelWidth" label="联系人" prop="contact_name">
            <el-input v-model="form.contact_name"></el-input>
          </el-form-item>
          <el-form-item :label-width="formLabelWidth" label="联系人电话" prop="phone">
            <el-input v-model="form.phone"></el-input>
          </el-form-item>
          <el-form-item :label-width="formLabelWidth" label="联系人邮箱" prop="email">
            <el-input v-model="form.email"></el-input>
          </el-form-item>
          <el-form-item :label-width="formLabelWidth" label="选择产品" prop="edition">
            <el-select v-model="form.edition" value-key="id" filterable placeholder="请选择" @change="selectEditon">
              <el-option v-for="item in editions" :key="item.name" :label="item.name" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label-width="formLabelWidth" label="选择版本" prop="edition">
            <el-select v-model="form.grade" value-key="id" filterable placeholder="请选择" @change="selectGrade">
              <el-option v-for="item in productVersion" :key="item.name" :label="item.name" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item v-if="isAdd == 'edit'" :label-width="formLabelWidth" label="选择版本" prop="edition">
          <el-select v-model="form.grade" filterable placeholder="请选择" :disabled="true">
            <el-option v-for="item in productVersion" :key="item.name" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label-width="formLabelWidth"
          v-if="form.expire_time != '买断'"
          :label="isAdd === 'triall' ? '试用时长' : '购买时长'"
          prop="months"
        >
          <el-select v-model="form.months" @change="changeBuyDate" filterable placeholder="请选择">
            <template v-if="isAdd != 'triall'">
              <el-option v-for="item in buyTime" :key="item.value" :label="item.name" :value="item.value"> </el-option>
            </template>
            <template v-if="isAdd == 'triall'">
              <el-option :key="7" label="七天" :value="7"> </el-option>
              <el-option :key="15" label="十五天" :value="15"> </el-option>
              <el-option :key="30" label="一个月" :value="30"> </el-option>
            </template>
            <!-- <el-option v-if="isAdd == 'edit'" :key="0" label="只增购模块" :value="0"> -->
            <!-- </el-option> -->
          </el-select>
        </el-form-item>

        <!-- <div class="block" v-if="this.isAdd == 'edit'">
            <div class="label">当前有效期 {{ this.form.expire_time }}</div>
            <div class="label">购买后有效期 {{ new_expire_time }}</div>
          </div> -->
        <!-- <div class="context">
            <p>增值模块</p>
            <el-table ref="elTable" :data="modules" style="width: 100%; margin-bottom: 20px" row-key="id" border @select="selectChange" @select-all="selectAllChange">
              <el-table-column type="selection" width="55" :selectable="checkSelctRow">
              </el-table-column>
              <el-table-column prop="name" label="模块名称" width="180">
              </el-table-column>
              <el-table-column label="授权信息">
                <template slot-scope="scope">
                  <span v-if="
                      currentSelectModuels.indexOf(scope.row.code) == -1 ||
                      !form.expire_time
                    "></span>
                  <span v-else-if="form.expire_time == '买断'">购买后有效期 {{ form.expire_time }}</span>
                  <span v-else>购买后有效期 {{ new_expire_time }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div> -->
        <!-- <div v-if="isAdd === 'triall'"> -->
        <el-form-item v-if="isAdd !== 'edit'" :label-width="formLabelWidth" label="备注" prop="note">
          <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="form.note"> </el-input>
        </el-form-item>
        <!-- </div> -->
        <!-- <div v-if="isAdd != 'triall'">
          <el-form-item :label-width="formLabelWidth" label="支付方式" prop="pay_type">
            <el-radio-group v-model="form.pay_type">
              <el-radio :label="1">小智专用币优先</el-radio>
              <el-radio :label="2">通用币优先</el-radio>
            </el-radio-group>
          </el-form-item>
        </div> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('form', (visible = false))">取 消</el-button>
        <el-button v-if="isAdd == 'triall'" class="primary" @click="triallClick">申请试用</el-button>
        <el-button v-else class="primary" @click="buyClick">预览价格</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getXZEditions } from '@/api/auth';
import {
  getXZAuthList,
  buyXZ,
  addXZMonth,
  addXZMonthPrice,
  buyXZPrice,
  trailXZ,
  trialXZDelay,
  getXZLicense,
} from '@/api/xzr_auth';
import { checkAgentPrice } from '@/api/agent';
import { payType } from '@/utils/dataDict';
import { payVerify } from '@/utils/pay';
import { getVersionOption, getseriesNameOption } from './utils';
export default {
  data() {
    const checkdomain = (rule, value, callback) => {
      let valid = true;
      for (let index = 0; index < this.auth_ips.length; index++) {
        const el = this.auth_ips[index];
        if (!el.value) {
          valid = false;
          break;
        }
      }
      if (!valid) {
        callback(new Error('IP/域名不能为空'));
      } else {
        callback();
      }
    };
    return {
      auth_ips: [{ value: '' }], // 授权外网IP数组
      Internal_auth_ips: [{ value: '' }], // 授权内网IP数组
      new_expire_time: '',
      modifyId: null,
      isAdd: 'add',
      currentBuyTime: null,
      payType,
      visible: false,
      formLabelWidth: '110px',
      form: {
        name: '', //用户名称
        contact_name: '', //联系人
        phone: '', // 固话
        email: '', // 电子邮箱
        // trail_days: 30, // 试用天数
        months: null,
        pay_type: 1,
        edition: '', // 版本
        // modules: [],
        domain: '', // ip
        internal_domain: '', // 内网ip
        note: '', // 备注
        grade: '',
      },
      formRules: {
        name: [
          {
            required: true,
            message: '请输入授权客户名称',
            trigger: 'blur',
          },
        ],
        domain: [{ validator: checkdomain, trigger: 'blur' }],
        code: [
          {
            required: true,
            message: '请输入授权码',
            trigger: 'blur',
          },
          {
            pattern: /^[0-9a-zA-Z]{1,}$/,
            message: '只支持输入数字、字母',
            trigger: 'blur',
          },
        ],
        key: [
          {
            required: true,
            message: '请输入授权码密码',
            trigger: 'blur',
          },
          {
            pattern: /^[0-9a-zA-Z]{1,}$/,
            message: '只支持输入数字、字母',
            trigger: 'blur',
          },
        ],
        contact_name: [
          {
            required: true,
            message: '请输入客户联系人',
            trigger: 'blur',
          },
        ],
        phone: [
          {
            required: true,
            message: '请输入联系人电话',
            trigger: 'blur',
          },
        ],
        email: [
          {
            required: true,
            message: '请输入联系人邮箱',
            trigger: 'blur',
          },
          {
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: 'blur',
          },
        ],
      },
      isSelectAll: false,
      modules: [],
      xzProducts: {},
      editions: [],
      buyTime: [{ name: '一年', value: 12 }, { name: '两年', value: 24 }, { name: '三年', value: 36 }],
      edittions: [],
      lockModuels: {}, //必须跟着版本购买的模块
      currentSelectModuels: [],
      productVersion: [],
      optionalVersion: {}, //根据产品选择可选版本
    };
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    addIP() {
      this.auth_ips.push({ value: '' });
    },
    addInternalIP() {
      this.Internal_auth_ips.push({ value: '' });
    },
    getUserInfo() {
      this.userInfo = this.$store.getters.userInfo;
    },
    removeIp(index) {
      this.auth_ips.splice(index, 1);
    },
    removeInternalIp(index) {
      this.Internal_auth_ips.splice(index, 1);
    },
    changeBuyDate() {
      this.accreditDate();
    },
    accreditDate() {
      let date = new Date(this.form.expire_time);
      if (this.isAdd != 'edit') {
        date = new Date();
        this.form.expire_time = `${date.getFullYear()}-${this.formatDate(date.getMonth() + 1)}-${this.formatDate(
          date.getDate(),
        )}`;
      }
      if (this.form.expire_time == '买断') {
        //过期时间为买断
        this.new_expire_time = '买断';
      } else if (this.form.expire_time && date >= new Date()) {
        //判断有过期时间并且在没过期时间范围内
        if (this.form.months === 0) {
          //购买时长为只购买模块
          this.new_expire_time = `${date.getFullYear()}-${this.formatDate(date.getMonth() + 1)}-${this.formatDate(
            date.getDate(),
          )}`;
        } else if (this.form.months === 10000) {
          //购买时长为买断
          this.new_expire_time = '买断';
        } else {
          //购买时长N(1)年
          date.setMonth(date.getMonth() + this.form.months);
          this.new_expire_time = `${date.getFullYear()}-${this.formatDate(date.getMonth() + 1)}-${this.formatDate(
            date.getDate(),
          )}`;
        }
      }
      //else{
      //   date = new Date()
      //   this.new_expire_time = `有效期至${date.getFullYear()}-${this.formatDate(date.getMonth()+1)}-${this.formatDate(date.getDate())}`
      // }
    },
    getBuyMonths(code) {
      if (!this.lockModuels[code]) {
        if (this.currentSelectModuels.indexOf(code) != -1) {
          if (this.form.expire_time) {
            let date = new Date(this.form.expire_time);
            let now = new Date();
            if (now < date) {
              //未过期
              return `${this.form.months}个月+补购${Math.floor((date - now) / 86400000)}天`;
            }
          }
        }
      }
      return this.form.months + '个月';
    },
    formatDate(num) {
      let result = num + '';
      if (result.length < 2) {
        result = '0' + result;
      }
      return result;
    },
    async show(obj) {
      const res = await getXZEditions();
      if (res) {
        let data = this.filterAPI(res);
        this.parseVersion(data);
        this.buyTimeHandle(data);
        this.initEditions(data);
      }
      this.visible = true;
      if (this.isAdd == 'edit') {
        this.modifyId = obj.id;
        this.form.name = obj.name;
        this.form.edition = obj.edition;
        this.form.expire_time = obj.expire_time;
        this.form.grade = obj.grade;
        // this.selectEditon(obj.grade);
        this.selectEditon(obj.edition);
        this.selectGrade(obj.grade);
      } else if (this.isAdd == 'triall') {
        this.form.months = 30;
      }
    },
    initEditions(data) {
      const newSetedition = [...new Set(data.map((i) => i.edition))];
      this.editions = [];
      newSetedition.forEach((item) => {
        this.editions.push(
          getseriesNameOption().find((i) => {
            return i.value === item;
          }),
        );
      });
    },
    getips() {
      if (this.auth_ips.length == 1) {
        return this.auth_ips[0].value;
      }
      return this.auth_ips
        .map((item) => {
          return item.value;
        })
        .join(',');
    },
    geInternaltips() {
      if (this.Internal_auth_ips.length == 1) {
        return this.Internal_auth_ips[0].value;
      }
      return this.Internal_auth_ips.map((i) => i.value).join(',');
    },
    triallClick() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let obj = {
            trail_days: this.form.months,
          };
          obj.name = this.form.name;
          obj.note = this.form.note;
          obj.phone = this.form.phone;
          obj.contact_name = this.form.contact_name;
          obj.email = this.form.email;
          obj.edition = this.form.edition;
          obj.grade = this.form.grade;
          obj.domain = this.getips();
          obj.internal_domain = this.geInternaltips();
          console.log(obj, 'objobj');
          trailXZ(obj)
            .then(() => {
              this.loading = false;
              this.$message({
                type: 'success',
                message: '申请试用成功',
              });
              this.resetForm();
              this.$parent.getAuthData();
              this.visible = false;
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
    resetForm() {
      this.form = {
        name: '', //用户名称
        contact_name: '', //联系人
        phone: '', // 固话
        email: '', // 电子邮箱
        // trail_days: 30, // 试用天数
        months: null,
        pay_type: 1,
        edition: '', // 版本
        grade: '',
        domain: '', // 外网ip
        internal_domain: '', // 内网ip
        note: '', // 备注
      };
      this.auth_ips = [{ value: '' }];
      this.Internal_auth_ips = [{ value: '' }];
    },
    buyClick() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let obj = {
            months: this.form.months,
            pay_type: this.form.pay_type,
          };
          if (this.isAdd == 'add') {
            obj.name = this.form.name;
            obj.contact_name = this.form.contact_name;
            obj.phone = this.form.phone;
            obj.email = this.form.email;
            obj.edition = this.form.edition;
            obj.domain = this.getips();
            obj.internal_domain = this.geInternaltips();
            obj.note = this.form.note;
            this.buySubmit(obj);
          } else if (this.isAdd == 'edit') {
            this.modifyBuySubmit(obj);
          }
        }
      });
    },
    buySubmit(obj) {
      let priceObj = {
        pay_type: this.form.pay_type,
        months: this.form.months,
        edition: this.form.edition,
        grade: this.form.grade,
        domain: obj.domain,
        internal_domain: obj.internal_domain,
      };
      buyXZPrice(priceObj)
        .then((res) => {
          this.$store
            .dispatch('user/userinfo') //获取账户余额
            .then(() => {
              this.loading = false;
              let finance = {
                special: this.$store.getters.userInfo.finance.xz_point,
                universal: this.$store.getters.userInfo.finance.point,
              };
              let parms = {
                price: res.price,
                payType: this.form.pay_type,
              };
              let result = payVerify(parms, finance, '小智产品'); //检测余额是否足够
              this.$confirm(`${result.msg}，是否购买？`, '支付信息', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
              })
                .then(() => {
                  buyXZ(Object.assign(obj, priceObj)).then((res) => {
                    this.$message({
                      type: 'success',
                      message: '购买成功!',
                    });
                    this.resetForm();
                    this.visible = false;
                    this.$parent.getAuthData();
                  });
                })
                .catch(() => {
                  this.$message({
                    type: 'info',
                    message: '已取消购买',
                  });
                });
            });
        })
        .catch((err) => {});
    },
    modifyBuySubmit(obj) {
      let priceObj = {
        pay_type: this.form.pay_type,
        months: this.form.months,
        // modules: this.currentSelectModuels.join(","),
      };
      addXZMonthPrice(this.modifyId, priceObj)
        .then((res) => {
          this.$store
            .dispatch('user/userinfo') //获取账户余额
            .then(() => {
              this.loading = false;
              let finance = {
                special: this.$store.getters.userInfo.finance.xz_point,
                universal: this.$store.getters.userInfo.finance.point,
              };
              let parms = {
                price: res.price,
                payType: this.form.pay_type,
              };
              let result = payVerify(parms, finance, '小智产品'); //检测余额是否足够
              this.$confirm(`${result.msg}，是否购买？`, '支付信息', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
              })
                .then(() => {
                  addXZMonth(this.modifyId, obj).then((res) => {
                    this.$message({
                      type: 'success',
                      message: '购买成功!',
                    });
                    this.resetForm();
                    this.visible = false;
                    this.$parent.getAuthData();
                  });
                })
                .catch(() => {
                  this.$message({
                    type: 'info',
                    message: '已取消购买',
                  });
                });
            });
        })
        .catch((err) => {});
    },
    restForm(done) {
      this.cancel();

      done();
    },
    cancel(formName, close) {
      this.resetForm();
      this.modifyId = null;
      this.isAdd = 'add';
    },
    checkSelctRow(row) {
      if (row.code == this.lockModuels[row.code]) {
        return false;
      } else {
        return true;
      }
    },
    selectChange(selection, row) {
      this.currentSelectModuels = selection.map((val) => {
        return val.code;
      });
    },
    selectAllChange(selection) {
      this.currentSelectModuels = selection.map((val) => {
        return val.code;
      });
      //全选、反全选
      // this.isSelectAll = !this.isSelectAll;
      // if (this.isSelectAll == false) {
      //   this.$refs.elTable.clearSelection();
      // } else {
      //   selection.forEach((item) => {
      //     if (item.children) {
      //       item.children.forEach((item) => {
      //         this.$refs.elTable.toggleRowSelection(item, true);
      //       });
      //     }
      //   });
      // }
    },
    changeMonths(item) {
      for (const e of this.editions) {
        if (e.value == item) {
          item = e;
          break;
        }
      }
      console.log(item, this.editions);
      if (item.buyout_valid && item.valid) {
        this.buyTime = [
          { name: '一年', value: 12 },
          { name: '两年', value: 24 },
          { name: '三年', value: 36 },
          { name: '买断', value: 10000 },
        ];
      } else if (item.buyout_valid) {
        this.buyTime = [{ name: '买断', value: 10000 }];
      } else if (item.valid) {
        this.buyTime = [{ name: '一年', value: 12 }, { name: '两年', value: 24 }, { name: '三年', value: 36 }];
      }
    },
    /* 去掉api服务 */
    filterAPI(res) {
      const FILTER_EDITIONS = 201;
      return res.filter((i) => i.edition !== FILTER_EDITIONS);
    },
    parseVersion(data) {
      const result = {};
      data.forEach((item) => {
        if (result[item.edition]) {
          result[item.edition].push(item.grade);
        } else {
          result[item.edition] = [item.grade];
        }
      });
      this.optionalVersion = result;
    },
    buyTimeHandle(data) {
      const result = {};
      data.forEach((item) => {
        const { buyout_valid, grade, valid } = item;
        if (result[item.edition]) {
          result[item.edition].push({ grade, buyout_valid, valid });
        } else {
          result[item.edition] = [{ grade, buyout_valid, valid }];
        }
      });
      this.buyTimeHandleData = result;
    },
    selectEditon(value) {
      /* 编辑模式 */
      if (this.isAdd === 'edit') {
        this.productVersion = [
          { name: '免费版', value: 1 },
          { name: '标准版', value: 2 },
          { name: '高级版', value: 3 },
          { name: '旗舰版', value: 4 },
        ];
        return;
      }
      /* 添加模式 */
      this.form.grade = '';
      this.form.months = '';
      const result = [];
      this.optionalVersion[value].forEach((item) => {
        let option = getVersionOption().find((i) => i.value === item);
        if (option) {
          result.push(option);
        }
        this.productVersion = result;
      });
    },
    selectGrade(grade) {
      this.buyTime = [];
      this.form.months = '';
      const { edition } = this.form;
      const result = this.buyTimeHandleData[edition];
      if (grade && result) {
        const data = result.find((item) => item.grade == grade);
        if (data) {
          const { valid, buyout_valid } = data;
          if (valid) {
            this.buyTime.push({ name: '一年', value: 12 }, { name: '两年', value: 24 }, { name: '三年', value: 36 });
          }
          if (buyout_valid) {
            //有买断的权限才有这个选项
            this.buyTime.push({ name: '买断', value: 10000 });
          }
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.xz_buyDialog {
  div {
    // box-sizing: border-box;
  }

  .input_bottom {
    margin-bottom: 10px;
  }

  /deep/ .el-dialog__body {
    padding: 30px 20px 0px 20px !important;
  }

  .ip_valid:before {
    content: '*';
    color: #f56c6c;
    margin-right: 4px;
  }

  .ip_main {
    .ip_input_main {
      display: inline-block;
      width: 100%;

      .add_span {
        width: 80px;
        text-align: center;
        color: #409eff;
        cursor: pointer;

        i {
          font-size: 20px;
        }
      }
    }
  }

  .ip_main :not(:last-child) {
    margin-bottom: 10px;
  }

  .info {
    margin: 10px 5px;
    border: 1px solid rgb(233, 233, 233);
    border-radius: 10px;
    box-shadow: rgba(0, 0, 0, 0.047) 0px 0px 5px;

    .input_box {
      padding: 0 50px;
      margin-top: 20px;

      // margin-bottom: 10px;
      .block {
        display: inline-block;
        margin-right: 85px !important;
        margin-top: 0 !important;
        margin-bottom: 10px !important;
        width: 178px;

        .autocomplete {
          width: 100%;
        }

        .el-form-item {
          margin-bottom: 0px;
        }
      }

      .block:last-child {
        margin-right: 0 !important;
      }

      .label {
        margin-bottom: 5px;
        font-size: 13px;

        span {
          color: #ff0000;
        }
      }
    }

    .title {
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      border-bottom: 1px solid rgb(233, 233, 233);
      font-size: 16px;
      font-weight: 650;
      padding: 15px 20px;
      background: #f9f9f9;
    }
  }

  .company_info {
    padding-bottom: 20px;
  }

  .authorization_info {
    .context {
      padding: 20px 50px;

      p {
        font-size: 13px;
        margin-bottom: 5px;
      }
    }
  }

  .pay_info {
    padding-bottom: 20px;
  }

  .price {
    float: left;
    text-align: left;
    font-size: 16px;

    span {
      color: #ff0000;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/xzReport/buyProduct.vue